import { EltType } from 'legacy/lut/components/widgets/public/partner360/ELT'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../configs/translations'

export const getEltFormatLabelKey = (eltType: EltType): string =>
  eltType === EltType.Pptx
    ? FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.createRow.eltFormatOld
    : FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.createRow.eltFormatNew
